import type { z } from "zod";

import { zSchema } from "../../../../entity";

const zOutSchema = zSchema;
type OutSchema = z.infer<typeof zOutSchema>;

export { zOutSchema };
export type { OutSchema };
